
const isSnakecase = value => value.match(/^[a-z]+_[a-z]+/)
const toCamelcase = key => key.replace(/(_\w)/g, (k) => k[1].toUpperCase())
const validObject = value => value && typeof (value) === 'object'

const handleObject = (value, classProxy) => {
  if (Array.isArray(value))
    return value.map(v => handleObject(v, classProxy))
  else if (validObject(value))
    return classProxy.build(value)
  else
    return value
}
  const deepNested = (obj, keys) => {
    const key = keys.shift()
    const value = obj[key]

    if (validObject(value) && keys.length > 0)
      return deepNested(value, keys)
    else
      return value
  }

export default class EntityProxy {
  static build(value) {
    if (Array.isArray(value))
      return value.map((v) => new this(v))

    return new this(value)
  }

  static clone(data, attributes = {}) {
    if (Array.isArray(data))
      return data.map(d => this.clone(d, attributes))
    else if (validObject(data))
      return new this({ ...data, ...attributes })
    else
      return data
  }

  static deepClass() {
    return this
  }

  constructor(attributes, options= { deep: true }) {
    if (!validObject(attributes))
      throw 'Must pass an Object'

    const handleValue = value => {
      if (options.deep)
        return handleObject(value, this.constructor.deepClass())
      else
        return value
    }

    for (const key in attributes) {
      this[key] = handleValue(attributes[key])

      if (!isSnakecase(key))
        continue

      const keyCamelcase = toCamelcase(key)
      Object.defineProperty(this, keyCamelcase, {
        get: () => this[key],
        set: (value) => this[key] = value
      })
    }
  }

  each(callback) {
    if (!(typeof callback === 'function'))
      return
    Object.entries(this).forEach(([key, value]) => callback(key, value))
  }

  dig(...keys) {
    return deepNested(this, keys)
	}

  clone(attributes = {}) {
    return EntityProxy.clone(this, attributes)
  }
}
